import PHPCookie from './PHPCookie';
import NodeCookie from './NodeCookie';

export default class CookieGenerator {
  constructor(...affiliates) {
    this._affiliates = affiliates.reduce((accumulator, item) => {
      accumulator[item.affiliateName] = item;
      return accumulator;
    }, {});
  }

  async addForAffiliate(affiliateName) {
    if(this._affiliates.hasOwnProperty(affiliateName)) {
      const otherAffiliatesNames = Object.keys(this._affiliates).filter(key => key !== affiliateName);
      const { phpCookies, nodeCookies } = this.splitByDomain(otherAffiliatesNames);
      await this.clearCookies(phpCookies, nodeCookies);
      return this._affiliates[affiliateName].prepareCookie();
    }
  }

  clearAffiliates() {
    //because server to server call covers php cookies already
    const { phpCookies, nodeCookies } = this.splitByDomain(Object.keys(this._affiliates))
    this.clearCookies(nodeCookies);
  }

  splitByDomain(otherAffiliates) {
    let phpCookies = [];
    let nodeCookies = [];

    otherAffiliates.forEach(name => {
      if (this._affiliates[name].cookieDomain instanceof PHPCookie) {
        phpCookies = phpCookies.concat(this._affiliates[name].cookieNames);
        return phpCookies;
      } else if (this._affiliates[name].cookieDomain instanceof NodeCookie) {
        nodeCookies = nodeCookies.concat(this._affiliates[name].cookieNames);
        return nodeCookies;
      }
    });

    return { phpCookies, nodeCookies }
  }

  async clearCookies(nodeCookiesList = [], phpCookiesList = []) {
    let promises = [];
    if (phpCookiesList.length > 0) {
      promises.push((new PHPCookie()).removeCookies(phpCookiesList))
    }

    if (nodeCookiesList.length > 0) {
      promises.push((new NodeCookie()).removeCookies(nodeCookiesList))
    }

    return Promise.allSettled(promises);
  }
}


// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/CookieGenerator.js